<template>
    <v-layout wrap justify-center>
        <v-flex xs12 sm8 md8 class="pa-2">
            <slot />
        </v-flex>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'OneColumnDetailsPane',
})
export default class OneColumnDetailsPane extends Vue {}
</script>
